export default {
  groupName: 'heb',
  appName: 'HEB',
  baseRoute: '/dashboard/heb',
  label: 'Ad Tracker',
  home: '/slicer',
  image: 'heb.png',
  description: 'HEB Ad Tracker Dashboard'
};


// WEBPACK FOOTER //
// ./src/app/configuration/HEB/config/main.js